import type { FaireProductEntity } from "../../entity_types/product";

export const p_fs87xaj2tm: FaireProductEntity = {
  token: "p_fs87xaj2tm",
  type: "product",
  name: "Kacela Brass Round Sculpture Taper Candle Holder Metal",
  brandName: "Foreside Home & Garden",
  imageUrl:
    "https://cdn.faire.com/fastly/039a3aa173611db795f1e2583d710f7aac58e72fcb07ed08392aab80fa9bf62a.jpeg",
  priceDollars: 6.39,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/ac3c5d2b52fb3c740c3ac6bf9077c6d0d9645200aa18677454d971845f81a599.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
